import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import TextField from '../../components/form/TextField';
import ColumnLayout from '../../components/layout/ColumnLayout';
import Grid from '../../components/layout/Grid';
import Button from '../../components/form/Button';
import Checkbox from '../../components/form/Checkbox';
import Inline from '../../components/layout/Inline';
import UploadField, { getFileName } from '../../components/form/UploadField';
import PlaqueOrderModal from './Modals/PlaqueOrderModal';
import PlaqueOrder from '../../fragments/PlaqueOrder';
import Select from '../../components/form/Select';
import FlexGrid from '../../components/layout/FlexGrid';
import ImageDetailsCard from '../../components/cards/ImageDetailsCard';
import AlertModal from '../../components/modal/AlertModal';
import ViewImageModal from './Modals/ViewImageModal';
import { deleteTypeName } from '../../utils/objects';
import { MAX_PLAQUE_LINES } from './PlaqueConstants';
import cloneDeep from 'lodash.clonedeep';

class PlaqueDetailsTab extends Component {
    state = {
        showPlaqueOrderModal: false,
        showDeleteImageModal: false,
        showImageDetailsModal: false,
        viewingPhotoIndex: null,
        deletingPhoto: null,
    };

    render() {
        const {
            showPlaqueOrderModal,
            showDeleteImageModal,
            showImageDetailsModal,
            viewingPhotoIndex
        } = this.state;
        const { form } = this.props;

        const photos = form.getField('PlaquePhotos');

        return (
            <Fragment>
                <ColumnLayout>
                    {this.renderLeftColumn()}
                    {this.renderRightColumn()}
                </ColumnLayout>

                <PlaqueOrderModal
                    open={showPlaqueOrderModal}
                    onClose={() => this.handleClosePlaqueOrderModal()}
                    parentForm={form}
                    orderLocation={form.getField('PlaqueLocation')}
                    productOrder={form.getField('ProductOrder')}
                />

                <ViewImageModal
                    open={showImageDetailsModal}
                    onClose={() => this.handleCloseImageDetailsModal()}
                    onSave={photo => this.handleSaveImageDetailsModal(photo)}
                    photo={photos[viewingPhotoIndex]}
                />

                <AlertModal
                    variant="warning"
                    open={showDeleteImageModal}
                    title="Prompt"
                    secondaryAction="Yes, Delete"
                    onClickSecondaryAction={() => this.handleDeletePlaqueImage()}
                    primaryAction="Cancel"
                    onClickPrimaryAction={() => this.handleCloseDeleteImageModal()}
                    onClose={() => this.handleCloseDeleteImageModal()}
                >
                    <p>You're about to delete an image.</p>
                    <p>Are you sure?</p>
                </AlertModal>
            </Fragment>
        );
    }

    renderLeftColumn() {
        return (
            <Fragment>
                {this.renderPlaqueOrder()}
                {this.renderOrderConsiderations()}
            </Fragment>
        );
    }

    renderPlaqueOrder() {
        const { form } = this.props;
        const product = form.getField('ProductOrder.Product');
        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Plaque Order</h4>
                </Grid>

                {!!form.getField('ProductOrder') && !!form.getField('ProductOrder').ID ? (
                    <Fragment>
                        <Grid item>
                            <h5>{!!product && product.Title}</h5>
                        </Grid>

                        <Grid item>
                            <Inline>
                                <Button variant="primary" onClick={() => this.handleShowPlaqueOrderModal()}>
                                    Edit Order...
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={() =>
                                        form.setField({
                                            ProductOrderID: 0,
                                            ProductOrder: {
                                                Niche: null,
                                                NicheCoordinates: null,
                                                Product: null,
                                                Location: null
                                            }
                                        })
                                    }
                                >
                                    Remove Order
                                </Button>
                            </Inline>
                        </Grid>
                    </Fragment>
                ) : (
                    <Grid item>
                        <Inline>
                            <Button variant="primary" onClick={() => this.handleShowPlaqueOrderModal()}>
                                Add Order...
                            </Button>
                        </Inline>
                    </Grid>
                )}
            </Grid>
        );
    }

    renderBorderDetails() {
        const { form } = this.props;
        const combination = this.getPlaqueCombination();

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Design Options</h4>
                </Grid>

                <Grid item xs={12}>
                    <Inline>
                        <Checkbox label="Flower border" form={form} name="FlowerBorder" />
                        <Checkbox label="Raised border" form={form} name="RaisedBorder" />
                    </Inline>
                </Grid>

                {!!combination && !!combination.BorderTypes && combination.BorderTypes.length > 0 && (
                    <Grid item sm={12} md={6}>
                        <Select
                            label="Border Details"
                            placeholder="Select a border type"
                            name="BorderDetails"
                            form={form}
                            options={combination.BorderTypes.map(obj => {
                                return {
                                    label: obj.Title,
                                    value: obj.Title
                                };
                            })}
                        />
                    </Grid>
                )}

                {!!combination && !!combination.Optionals && (
                    <Grid item sm={12} md={6}>
                        <Select
                            label="Optionals"
                            placeholder="Select an optional"
                            options={combination.Optionals.map(obj => {
                                return {
                                    label: obj.Title,
                                    value: obj.Title
                                };
                            })}
                        />
                    </Grid>
                )}

                {this.renderPlaquePhoto()}
            </Grid>
        );
    }

    renderPlaqueWording() {
        const { form } = this.props;

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Plaque Wording</h4>
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        placeholder="Enter the plaque wording here..."
                        multiline
                        name="PlaqueWordingLines"
                        form={form}
                        onChange={this.updateAdditionalLines}
                        onBlur={e => {
                            form.setField({ PlaqueWordingLines: e.target.value ? e.target.value.trim() : null });
                            this.updateAdditionalLines();
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField label="Number of lines included" value={MAX_PLAQUE_LINES} readOnly />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        label="Additional lines"
                        type="Number"
                        name="PlaqueWordingAdditionalLines"
                        form={form}
                        emptyValue="0"
                        readOnly
                    />
                </Grid>
            </Grid>
        );
    }

    renderRightColumn() {
        return (
            <Fragment>
                {this.renderBorderDetails()}
                {this.renderPlaqueWording()}
            </Fragment>
        );
    }

    renderPlaquePhoto() {
        const { form } = this.props;
        const photos = form.getField('PlaquePhotos');

        return (
            <Fragment>
                <Grid item>
                    <Checkbox label="Match plaque to photo?" name="MatchPlaqueToPhoto" form={form} />
                </Grid>
                {!!form.getField('MatchPlaqueToPhoto') && (
                    <Fragment>
                        <Grid item>
                            <h4>Upload an image</h4>
                        </Grid>

                        <Grid item>
                            <UploadField
                                folderPath={`/documents/plaque/${form.getField('ID')}`}
                                onComplete={({ uploadFile }) => this.handleUploadAttachment(uploadFile, photos)}
                            />
                        </Grid>

                        {!!photos && !!photos.length && (
                            <Fragment>
                                <Grid item>
                                    <h4>The following images have been uploaded</h4>
                                </Grid>

                                <Grid item>
                                    {/*Image cards will only appear after images have been added*/}
                                    <FlexGrid variant="justify">
                                        {photos.map((photo, index) => (
                                            <ImageDetailsCard
                                                key={'image-' + photo.ID}
                                                photo={photo}
                                                onClickOpenImage={() => this.handleShowImageDetailsModal(index)}
                                                onClickRemoveAction={() => this.handleShowDeleteImageModal(photo)}
                                            />
                                        ))}
                                    </FlexGrid>
                                </Grid>
                            </Fragment>
                        )}
                    </Fragment>
                )}
            </Fragment>
        );
    }

    renderOrderConsiderations() {
        const { form } = this.props;
        const combination = this.getPlaqueCombination();
        const contact = form.getField('PlaqueLocation');
        return (
            <Grid container bucket>
                <Grid item xs={12}>
                    <h4>Installation Method</h4>
                </Grid>

                {!!contact && !!contact.PlaqueCombinations && !!contact.PlaqueCombinations.length && (
                    <Grid item>
                        <Select
                            label="Combination"
                            options={contact.PlaqueCombinations.map(obj => {
                                return {
                                    label: obj.LocationType,
                                    value: obj.ID
                                };
                            })}
                            form={form}
                            name="PlaqueCombination.ID"
                            onChange={() => this.handleCombinationSelect()}
                        />
                    </Grid>
                )}

                <Grid item xs={12} sm={6}>
                    <TextField label="Plaque Position" form={form} name="PlaquePosition" />
                </Grid>

                <Grid item xs={12} sm={6}>
                    {!!combination && !!combination.MaterialOptions && !!combination.MaterialOptions.length ? (
                        <Select
                            label="Plaque Material"
                            options={combination.MaterialOptions.map(obj => {
                                return {
                                    label: obj.Title,
                                    value: obj.Title
                                };
                            })}
                            form={form}
                            name="PlaqueMaterial"
                        />
                    ) : (
                        <TextField label="Plaque Material" form={form} name="PlaqueMaterial" />
                    )}
                </Grid>

                <Grid item xs={12} sm={6}>
                    {!!combination && !!combination.AttachmentMethods && !!combination.AttachmentMethods.length ? (
                        <Select
                            label="Attachment Method"
                            options={combination.AttachmentMethods.map(obj => {
                                return {
                                    label: obj.Title,
                                    value: obj.Title
                                };
                            })}
                            form={form}
                            name="AttachmentMethod"
                        />
                    ) : (
                        <TextField label="Attachment Method" form={form} name="AttachmentMethod" />
                    )}
                </Grid>

                <Grid item xs={12} sm={6}>
                    {!!combination && !!combination.WallPositions && !!combination.WallPositions.length ? (
                        <Select
                            label="Wall Position"
                            options={combination.WallPositions.map(obj => {
                                return {
                                    label: obj.Title,
                                    value: obj.Title
                                };
                            })}
                            form={form}
                            name="WallPosition"
                        />
                    ) : (
                        <TextField label="Wall Position" form={form} name="WallPosition" />
                    )}
                </Grid>
            </Grid>
        );
    }

    handleCombinationSelect() {
        const { form } = this.props;
        const combination = this.getPlaqueCombination();
        if (combination) {
            const cloned = cloneDeep(combination);

            const Ashes = form.getState('Ashes') || [];
            if (Ashes.length) {
                Ashes[0].Ashes = cloned.AshesSelection;
                Ashes[0].ContainmentStyle = cloned.VaseType;
            } else {
                Ashes.push({
                    Ashes: cloned.AshesSelection,
                    ContainmentStyle: cloned.VaseType
                });
            }

            cloned.BorderDetails = cloned.BorderType;

            delete cloned.ID;
            delete cloned.LocationType;
            delete cloned.PlaqueSize;
            delete cloned.VaseType;
            delete cloned.AshesSelection;
            delete cloned.QuoteTemplatesAllowed;
            delete cloned.Location;
            delete cloned.WallPositions;
            delete cloned.MaterialOptions;
            delete cloned.Optionals;
            delete cloned.AttachmentMethods;
            delete cloned.BorderType;
            delete cloned.BorderTypes;
            delete cloned.__typename;

            const newState = Object.assign(form.state, cloned);
            newState.Ashes = Ashes;

            form.setState(newState);
        }
    }

    getPlaqueCombination() {
        const { form } = this.props;
        const combinationID = form.getField('PlaqueCombination.ID');
        const combinations = form.getField('PlaqueLocation.PlaqueCombinations');

        if (combinationID && combinations && combinations.length) {
            return combinations.find(obj => obj.ID === combinationID);
        }
        return null;
    }

    handleUploadAttachment(uploadFile, photos) {
        const { form } = this.props;
        photos = photos || [];

        photos.push({
            File: {
                ID: uploadFile.ID,
                AbsoluteLink: uploadFile.AbsoluteLink,
                Name: getFileName(uploadFile.FileName)
            }
        });

        form.setField({
            PlaquePhotos: photos
        });
        form.save();
    }

    updateAdditionalLines = () => {
        const { form } = this.props;
        const maxLines = /* form.getField('???') || */ MAX_PLAQUE_LINES;
        const text = form.getField('PlaqueWordingLines') || '';
        const lines = text.split(/\r|\r\n|\n/);
        form.setField({ PlaqueWordingAdditionalLines: Math.max(0, lines.length - maxLines) });
    };

    handleShowPlaqueOrderModal() {
        this.setState({ showPlaqueOrderModal: true });
    }

    handleClosePlaqueOrderModal() {
        this.setState({ showPlaqueOrderModal: false });
    }

    handleShowDeleteImageModal(photo) {
        this.setState({
            showDeleteImageModal: true,
            deletingPhoto: photo
        });
    }

    handleDeletePlaqueImage() {
        const { deletingPhoto } = this.state;
        const { form } = this.props;

        let PlaquePhotos = form.getField('PlaquePhotos');
        PlaquePhotos = PlaquePhotos.filter(obj => deletingPhoto.ID !== obj.ID);

        form.setField({ PlaquePhotos });
        form.save();

        this.setState({ showDeleteImageModal: false });
    }

    handleCloseDeleteImageModal() {
        this.setState({ showDeleteImageModal: false });
    }

    handleShowImageDetailsModal(index) {
        this.setState({
            showImageDetailsModal: true,
            viewingPhotoIndex: index
        });
    }

    handleSaveImageDetailsModal(photo) {
        const { form } = this.props;
        const PlaquePhotos = form.getField('PlaquePhotos');

        const { viewingPhotoIndex } = this.state;

        PlaquePhotos[viewingPhotoIndex] = photo;

        form.setField({ PlaquePhotos }, true);

        this.handleCloseImageDetailsModal();
    }

    handleCloseImageDetailsModal() {
        this.setState({ showImageDetailsModal: false });
    }
}

export default {
    id: 'PlaqueDetails',
    label: 'Plaque Details',
    component: withStyles({})(PlaqueDetailsTab),
    fragment: PlaqueOrder,
    formatSaveData: (saveData, state) => {
        if (!!state.ProductOrder && Number(state.ProductOrder.ID) > 0) {
            saveData.ProductOrder = state.ProductOrder;
            // saveData.ProductOrder.Niche = null;
            // saveData.ProductOrder.NicheCoordinates = null;
            // saveData.ProductOrder.Product = null;
            // saveData.ProductOrder.Location = null;
            if (saveData.ProductOrder.Product && saveData.ProductOrder.Product.Image) {
                saveData.ProductOrder.Product.ImageID = state.ProductOrder.Product.Image.ID;
                delete saveData.ProductOrder.Product.Image;
            }
            if (saveData.ProductOrder.Location) {
                saveData.ProductOrder.LocationID = state.ProductOrder.Location.ID;
                delete saveData.ProductOrder.Location;
            }

            deleteTypeName(saveData.ProductOrder);
        }

        const localPlaquePhotos = [];
        if (saveData && saveData.PlaquePhotos) {
            state.PlaquePhotos.forEach(function(plaquePhoto) {
                const photo = {};
                if (!!plaquePhoto.ID) {
                    // existing item, just include ID to retain
                    photo.ID = plaquePhoto.ID;
                    photo.Caption = plaquePhoto.Caption;
                    photo.Comment = plaquePhoto.Comment;
                } else {
                    // new item, omit ID to create
                    photo.FileID = plaquePhoto.File.ID;
                }
                localPlaquePhotos.push(photo);
            });
            saveData.PlaquePhotos = localPlaquePhotos;
        }
    }
};
